export const options = {
  textControl: true,
  textSpacing: true,
  lineHeight: true,
  keyboardNavigation: true,
  readingMask: true,
  readingBar: true,
  coloredDisplay: true,
  reverseContrast: true,
  brightContrast: true,
  pauseVideo: true,
  pauseAnimations: true,
  muteAudion: true,
  hideMedia: true,
  imageDescription: true,
  zoomOption: true,
  blackCursor: true,
  whiteCursor: true,
  focusOption: true,
};
